module.exports = __webpack_public_path__ + "media/images/flags/4x3/hrv-e598c7874b3a2ea01915e405b816e954.svg";